/**
 * Определение мобильного устройства по userAgent
 */
export const isMobile = (): boolean => {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent.toLowerCase();
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i.test(ua);
};

/**
 * iOS (iPhone / iPad)
 */
export const isIOS = (): boolean => {
    if (typeof navigator === 'undefined') return false;
    return /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase());
};

/**
 * Android
 */
export const isAndroid = (): boolean => {
    if (typeof navigator === 'undefined') return false;
    return /android/i.test(navigator.userAgent.toLowerCase());
};

/**
 * Приложение уже установлено и запущено как PWA (standalone / fullscreen).
 * В этом случае модалку «Установить приложение» не показываем.
 */
export const isStandalone = (): boolean => {
    if (typeof window === 'undefined') return false;
    // iOS Safari: при запуске с домашнего экрана
    const iosStandalone =
        'standalone' in navigator && (navigator as Navigator & { standalone?: boolean }).standalone === true;
    // Стандартный способ для PWA (Chrome, Android, часть iOS)
    const displayStandalone =
        window.matchMedia('(display-mode: standalone)').matches ||
        window.matchMedia('(display-mode: fullscreen)').matches ||
        window.matchMedia('(display-mode: minimal-ui)').matches;
    return iosStandalone || displayStandalone;
};
